export default __webpack_public_path__ + "static/board-5aaa1afe4e040abd4e7caed4e2816cd4.png";